'use strict';

exports.__esModule = true;

var _client = require('feathers/client');

var _client2 = _interopRequireDefault(_client);

var _feathersHooks = require('feathers-hooks');

var _feathersHooks2 = _interopRequireDefault(_feathersHooks);

var _feathersErrors = require('feathers-errors');

var _feathersErrors2 = _interopRequireDefault(_feathersErrors);

var _feathersAuthenticationClient = require('feathers-authentication-client');

var _feathersAuthenticationClient2 = _interopRequireDefault(_feathersAuthenticationClient);

var _client3 = require('feathers-rest/client');

var _client4 = _interopRequireDefault(_client3);

var _client5 = require('feathers-socketio/client');

var _client6 = _interopRequireDefault(_client5);

var _client7 = require('feathers-primus/client');

var _client8 = _interopRequireDefault(_client7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.assign(_client2.default, {
  socketio: _client6.default,
  primus: _client8.default,
  rest: _client4.default,
  hooks: _feathersHooks2.default,
  authentication: _feathersAuthenticationClient2.default,
  errors: _feathersErrors2.default
});

exports.default = _client2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/feathers-client/lib/client.js
// module id = 429
// module chunks = 3